import { render, staticRenderFns } from "./VcaSummaryStatus.vue?vue&type=template&id=1c260f6c&scoped=true"
import script from "./VcaSummaryStatus.vue?vue&type=script&lang=ts"
export * from "./VcaSummaryStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c260f6c",
  null
  
)

export default component.exports